var _excluded = ["className", "navItems", "menuButtonLabel", "menuItems", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { forwardRef, omitThemingProps, StylesProvider, tqc, useMultiStyleConfig } from '../../../system';
import { Container, Flex, UnderlineButton, MenuItem, MenuList, Menu, MenuButton } from '../../../components';
import { cx } from '../../../utils';
import { FaAngleDown } from 'react-icons/fa';
export var Header = forwardRef((props, ref) => {
  var _omitThemingProps = omitThemingProps(props),
    {
      className,
      navItems,
      menuButtonLabel,
      menuItems,
      children
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var styles = useMultiStyleConfig('Header', _objectSpread({}, props));
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.header, _extends({
    ref: ref
  }, rest, {
    className: cx('tqc-header', className),
    sx: styles.mainContainer
  }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, children, /*#__PURE__*/React.createElement(Flex, null, navItems.map(item => /*#__PURE__*/React.createElement(UnderlineButton, {
    key: item.label,
    gaAction: "navigate",
    gaCategory: "header",
    as: item.as,
    href: item.path,
    to: item.to,
    gaLabel: item.gaLabel,
    "data-testid": item.testId,
    isActive: item.isActive,
    color: "white",
    sx: styles.navItem
  }, item.label)), /*#__PURE__*/React.createElement(Menu, {
    placement: "bottom-end"
  }, /*#__PURE__*/React.createElement(MenuButton, {
    as: UnderlineButton,
    rightIcon: /*#__PURE__*/React.createElement(FaAngleDown, null),
    flex: "0 0 auto",
    "data-testid": "menu-button-my-account",
    sx: styles.menuButton
  }, menuButtonLabel), /*#__PURE__*/React.createElement(MenuList, {
    overflow: "hidden",
    mt: "-1px"
  }, menuItems.map(item => /*#__PURE__*/React.createElement(MenuItem, {
    key: item.label,
    gaAction: "navigate",
    gaCategory: "header",
    gaLabel: item.gaLabel,
    "data-testid": item.testId,
    sx: styles.menuItem,
    onClick: item.onClick
  }, item.label)))))))));
});
Header.displayName = 'Header';